/**
 * Single source of truth for the auth token in localStorage.
 * Per the spec (§3.6), no other module may read or write the token.
 * @module auth/token-storage
 */

const STORAGE_KEY = 'verdasync.token'

/**
 * @return {string|null}
 */
export function getToken() {
    if (typeof localStorage === 'undefined')
        return null
    try {
        return localStorage.getItem(STORAGE_KEY)
    } catch {
        return null
    }
}

/**
 * @param {string} token
 */
export function setToken(token) {
    if (typeof localStorage === 'undefined')
        return
    try {
        localStorage.setItem(STORAGE_KEY, token)
    } catch {
        // private mode / quota: nothing we can do — caller will get 401 next request
    }
}

export function clearToken() {
    if (typeof localStorage === 'undefined')
        return
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch {
        // ignore
    }
}

export const TOKEN_STORAGE_KEY = STORAGE_KEY
